

/*********************************** open dropdown menu on hover ***********************************/
let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
let dropdownItems = document.querySelector(".header__submenu");
items.forEach((item) => {
  let closeTimeout;
  item.addEventListener("mouseenter", () => {
    clearTimeout(closeTimeout); // Clear the timeout if re-entered
    item.setAttribute("open", true);
    let ulElement = item.querySelector("ul");
    if (ulElement !== null) {
      ulElement.addEventListener("mouseleave", () => {
        closeTimeout = setTimeout(() => {
          item.removeAttribute("open");
        }, 300); // Set 2-second delay before closing
      });
    }
  });
  item.addEventListener("focus", () => {
    clearTimeout(closeTimeout); // Clear the timeout if focused
    item.setAttribute("open", true);
  });
  item.addEventListener("blur", () => {
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 300); // Set 2-second delay before closing
  });
  item.addEventListener("mouseleave", () => {
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 300); // Set 2-second delay before closing
  });
});
if (dropdownItems !== null) {
  dropdownItems.addEventListener("mouseleave", () => {
    items.forEach((item) => {
      let closeTimeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 300); // Set 2-second delay for all items
    });
  });
}


/*********************************** home page hero section arrow visible on hover ***********************************/

$(".slider-mobile-gutter").hover(
  () => {
    //hover
    $(".slideshow__controls").addClass("show");
  },
  () => {
    //out
    $(".slideshow__controls").removeClass("show");
  }
);


/*********************************** product page image gallery verticle slider ***********************************/

$('.thumbnail-list').slick({
    dots: false,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    verticalSwiping: true,
    infinite:false,
    arrows: true,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0721/8901/8408/files/right.png?v=1703590131" alt="Previous" class="p-arrow">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0721/8901/8408/files/left.png?v=1703590131" alt="Next" class="n-arrow">',
    responsive:[
      {
        breakpoint: 1024, //YOUR MOBILE WIDTH
        settings: "unslick" //DISABLE SLIDER
      }
    ]
});


/*********************************** cusotm review home page ***********************************/
$(".carousel-inner").slick({
   arrows: true,
   dots: false,
   infinite: true,
   speed: 500,
   slidesToShow: 1,
   slidesToScroll: 1,
   responsive: [
     {
       breakpoint: 768,
       settings: {
        arrows: true,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
       },
     },
   ],
 });



